var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.389.5c2.792 0 5.229 1.345 7.295 3.548a16.75 16.75 0 011.84 2.364l.218.345c.133.217.24.405.324.558l.106.202a1 1 0 010 .895l-.106.202c-.083.153-.191.341-.324.558l-.218.345a16.75 16.75 0 01-1.84 2.364c-2.066 2.204-4.503 3.548-7.295 3.548s-5.23-1.344-7.295-3.548a16.75 16.75 0 01-1.84-2.364l-.218-.345c-.2-.325-.343-.585-.43-.76a1 1 0 010-.895c.087-.174.23-.435.43-.76l.217-.345a16.75 16.75 0 011.84-2.364C5.16 1.845 7.598.5 10.39.5zm0 2c-2.158 0-4.114 1.08-5.836 2.916-.495.528-.941 1.089-1.334 1.655l-.34.512-.236.382.086.143.204.324c.459.71 1 1.42 1.62 2.081 1.722 1.837 3.678 2.916 5.836 2.916 2.157 0 4.114-1.08 5.836-2.916a14.77 14.77 0 001.62-2.08l.107-.169.183-.3-.087-.143-.204-.324c-.458-.71-1-1.42-1.619-2.08C14.503 3.58 12.546 2.5 10.389 2.5zm0 2.04a3.424 3.424 0 110 6.849 3.424 3.424 0 010-6.849zm0 2a1.424 1.424 0 100 2.849 1.424 1.424 0 000-2.849z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b677a37c3c4d0e2e73ae410acddcb473.svg";
export { ForwardRef as ReactComponent };